import {
  WSElementProps,
  WSImage,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";
import amexLogo from "../../assets/images/credit-cards/amex.svg";
import discoverLogo from "../../assets/images/credit-cards/discover.svg";
import jcbLogo from "../../assets/images/credit-cards/jcb.svg";
import mastercardLogo from "../../assets/images/credit-cards/mastercard.svg";
import unionPayLogo from "../../assets/images/credit-cards/unionpay.svg";
import visaLogo from "../../assets/images/credit-cards/visa.svg";
import { CreditCardType } from "../../types/creditCard";

type Props = {
  type: CreditCardType;
} & WSElementProps;

export const CreditCardBrandLogo: React.FC<Props> = ({
  type,
  ...elementProps
}) => {
  let src, alt;

  switch (type) {
    case "amex":
      src = amexLogo;
      alt = "American Express Logo";
      break;
    case "discover":
      src = discoverLogo;
      alt = "Discover Logo";
      break;
    case "jcb":
      src = jcbLogo;
      alt = "JCB Logo";
      break;
    case "mastercard":
      src = mastercardLogo;
      alt = "MasterCard Logo";
      break;
    case "unionPay":
      src = unionPayLogo;
      alt = "UnionPay Logo";
      break;
    case "visa":
      src = visaLogo;
      alt = "Visa Logo";
      break;
    case "unknown":
    default:
  }

  if (src && alt)
    return (
      <WSImage
        src={src}
        placeholder={<WSText.Label>{alt}</WSText.Label>}
        {...elementProps}
      />
    );
  else return null;
};
